module.exports = "### ToolbarGroup Properties\n\n`ToolbarGroup` contains a collection of components for you. \nIt is recommended that all components in a `Toolbar` are contained within a `ToolbarGroup`.\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/Toolbars/ToolbarGroup.md
 ** module id = 894
 ** module chunks = 0
 **/